module.exports = __webpack_public_path__ + "img/preload-head-online.e1c0ca61.jpg";